import "./EditMindcareSettings.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditMindcareSettingsComponentController from "./EditMindcareSettingsComponentController";

export default class EditMindcareSettingsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditMindcareSettingsComponentController;
        this.templateUrl = "/App/Components/Partners/Details/EditMindcareSettings/EditMindcareSettings.html";
    }
}

module("mmManagePortal").component("irEditMindcareSettings", new EditMindcareSettingsComponent());
